<template>
  <div class="app-container">
    <list ref="list" @setDetails="setDetails">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <!-- <el-button type="info" @click="onPrintTemaplate">打印模板</el-button> -->
        <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="140">
          <template slot-scope="{ row }">
            <!-- <el-button type="text" @click="editById(row.DocId)">编辑</el-button>
            <el-button type="text" @click="delRows(row.DocId)">删除</el-button>-->
            <!-- <el-button @click="onPrint(row)" type="text">打印</el-button> -->
            <el-button type="text" v-if="row.Status!=2" @click="editById(row.DocId)">编辑</el-button>
            <el-button type="text" @click="check(row)">审核</el-button>
            <el-button type="text" v-if="row.Status!=2" @click="delRows(row.DocId)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
      <div class="list-head" style="margin-top: 10px;">
      <span>订单详情</span>
      <div class="list-detail">
        <span>订单号：{{row.DocNo||'-'}}</span>
        <span>业务员：{{row.ClerkName||'-'}}</span>
        <span>备注：{{row.Remark||'-'}}</span>
        <span>订单金额：{{ Math.floor(row.Amount*100)/100||'-' }}</span>
      </div>
    </div>
        <div class="thinScroll" :style="'px;overflow-y:auto;width:100%'">
      <el-row class="mb0">
        <el-table
          :data="Details"
          size="mini"
          border
          style="width:100%;">
          <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column prop="GoodsCode" label="条码" align="center" min-width="100"/>
           <el-table-column prop="WarehouseName" label="仓库"/>
          <el-table-column prop="GoodsName" label="商品名称" align="center" />
          <el-table-column prop="Model" label="规格型号" align="center" />
          <el-table-column prop="UnitName" label="单位" align="center"/>
           <el-table-column prop="Quantity" label="数量" width="90" align="center"/>
          <el-table-column prop="ExistQuantity" label="现存量" align="center"/>
          <el-table-column prop="AvailableQuantity" label="可用量" align="center"/>
          <el-table-column prop="Offer" label="报价" align="center">
            <template slot-scope="{ row }">
            {{row.Offer}}
            </template>
          </el-table-column>
          <el-table-column prop="Discount" label="折扣%" width="90" align="center"/>
          <el-table-column prop="Price" label="单价" width="90" align="center">
            <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Price)}}
            </template>
          </el-table-column>

          <el-table-column prop="SourcePrice" label="原单单价" width="90" align="center">
            <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.SourcePrice)}}
            </template>
          </el-table-column>
          
          <el-table-column prop="TaxRate" label="税率/%" width="90" align="center"/>
          <el-table-column prop="TaxAmount" label="税额" width="90" align="center">
            <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.TaxAmount)}}
            </template>
          </el-table-column>
          <el-table-column prop="Amount" label="含税金额" width="90" align="center">
            <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Amount)}}
            </template>
          </el-table-column>
          <el-table-column prop="NoTaxAmount" label="不含税金额" width="90" align="center">
            <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.NoTaxAmount)}}
            </template>
          </el-table-column>
          <el-table-column prop="Remark" label="备注" width="150px"/>
        </el-table>
      </el-row>
    </div>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sales/business/return/list";
import editDialog from "@/components/sales/business/return/editDialog";

export default {
  name: "comment",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },
  data() {
    return {
      api: require("@/api/sale/saBackDoc").default,
      Details: [],
      row: {},
    };
  },
  methods: {
    
    onPrintTemaplate() {
      var url = location.origin + "/#/customprint/" + "销货退货单";
      window.open(url, "_blank");
    },
    onPrint(row) {
      var url = location.origin + "/#/customprintview/销货退货单/" + row.DocId;
      window.open(url, "_blank");
    },
    setDetails(list,row) {
      
      this.Details = list;
      this.row = row
    },
    check(row) {
      sessionStorage.setItem("check", "1");
      this.editById(row.DocId);
    },
    delRows(id) {
      this.$confirm("确认删除数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete(id).then((res) => {
            if (res.Code == 0) {
              this.$message.success("删除成功");
              this.$refs.list.reload();
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>